import * as React from 'react';

import { Modal, Stack } from 'react-bootstrap';

import classNames from 'classnames';

interface IModalButton {
    cssClass?: string;
    label?: string;
    onClick: (suppressNotice: boolean) => void;
}

export interface IDismissableModalProps {
    bodyComponent: React.ReactNode;
    closeButton: IModalButton;
    open: boolean;
    submitButton: IModalButton;
    supressNotice?: string;
    title: string;
}

export function DismissableModal(props: IDismissableModalProps) {
    if (!props.open) return null;

    const [suppressNotice, setSuppressNotice] = React.useState<boolean>(false);

    const handleSuppressNoticeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSuppressNotice(event.target.checked);
    };

    const handleSubmitClick = () => props.submitButton.onClick(suppressNotice);
    const handleCloseClick = () => props.closeButton.onClick(suppressNotice);

    return (
        <>
            <Modal centered show={props.open} backdrop={true}>
                <Modal.Header>
                    <Modal.Title>{props.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{props.bodyComponent}</Modal.Body>
                <Modal.Footer>
                    <Stack
                        direction="horizontal"
                        style={{ justifyContent: 'space-between', width: '100%' }}
                    >
                        <div>
                            <label style={{ cursor: 'pointer' }}>
                                <input
                                    name="chkEasyUpdate"
                                    type="checkbox"
                                    className="form-check-input"
                                    onChange={handleSuppressNoticeChange}
                                    checked={suppressNotice}
                                />
                                &nbsp;{props.supressNotice ?? 'Hide popup for this session'}
                            </label>
                        </div>
                        <div>
                            <button
                                className={classNames('btn', props.submitButton.cssClass ?? 'btn-black')}
                                onClick={handleSubmitClick}
                            >
                                {props.submitButton.label ?? 'Ok'}
                            </button>
                            <button
                                className={classNames(
                                    'btn',
                                    props.closeButton.cssClass ?? 'btn-default'
                                )}
                                onClick={handleCloseClick}
                            >
                                {props.closeButton.label ?? 'Dismiss'}
                            </button>
                        </div>
                    </Stack>
                </Modal.Footer>
            </Modal>
        </>
    );
}
